export const shadowAndBorderClass = `
relative
border-none shadow-[0px_6px_7.5px_0px_#0000000F] max-lg:shadow-[0px_6px_7.5px_0px_#0000000F]
before:content-[''] before:absolute before:inset-0
before:p-px max-lg:before:p-px
before:rounded-[20px] max-lg:before:rounded-[20px]
before:[background:linear-gradient(107deg,rgba(161,161,170,0.55)_0%,rgba(113,113,122,0.22)_52%,rgba(82,82,91,0)_100%)]
before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
before:[-webkit-mask-composite:xor] before:[mask-composite:exclude]
before:z-[1] before:pointer-events-none
`;

export const gradientRowBgClass = `
relative border-none
shadow-[0px_6px_7.5px_0px_#0000000f] max-lg:shadow-[0px_6px_7.5px_0px_#0000000f]
bg-[linear-gradient(90deg,rgba(207,178,255,0.16)_0%,rgba(255,173,174,0.16)_60%,rgba(255,166,134,0.16)_100%),linear-gradient(0deg,rgba(26,26,26,1)_0%,rgba(26,26,26,1)_100%)]
before:content-[''] before:absolute before:inset-0
before:p-px max-lg:before:p-px
before:rounded-[20px] max-lg:before:rounded-[12px]
before:[background:linear-gradient(103deg,rgba(161,161,170,0.55)_0%,rgba(113,113,122,0.22)_52%,rgba(82,82,91,0)_100%)]
before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
before:[-webkit-mask-composite:xor] before:[mask-composite:exclude]
before:z-[1] before:pointer-events-none
`;

export const investButtonClass = `inline-flex disabled:!opacity-60 items-center justify-between gap-[12px] pl-[17px] max-lg:pl-[16px] pr-[12px] max-lg:pr-[12px] w-full !py-[12px] max-lg:!py-[12px] h-auto !rounded-full
                border-none shadow-[0px_6px_7.5px_0px_#0000000f]
                !bg-white hover:opacity-90 transition-opacity`;

/** White pill CTA used on Referrals (connect wallet, copy link, claim trigger). */
export const referralCtaButtonClass = `inline-flex items-center justify-between gap-[12px] pl-[17px] pr-[12px] max-lg:pr-[12px] max-lg:!py-[12px] max-lg:pl-[12px] !py-[12px] h-auto !rounded-full border-none shadow-[0px_6px_7.5px_0px_#0000000f] bg-white hover:opacity-90 transition-opacity disabled:opacity-55`;
